<template>
  <div class="form-container elevation-1">
    <v-form ref="form" @submit.prevent="submitClicked" v-if="!success">
      <h2 class="display-3">User Registration</h2>
      <div class="form-region">
        <v-text-field type="text" label="First name *" hint="Enter your first name." v-model="form.user.first" :rules=[rules.required]></v-text-field>
        <v-text-field type="text" label="Last name *" hint="Enter your last name." v-model="form.user.last" :rules=[rules.required]></v-text-field>
        <v-text-field type="text" label="Email address *" 
          v-model="form.user.email" autocapitalize="off" :rules=[rules.required]
        ></v-text-field>
        <p class="caption">You should register with a persistent valid email address. 
          Your email address will be used if you forget your password and need to recover your account. 
          If you use a temporary email address, you could lose access to your ThinkSpatial account and be unable to recover it
          </p>
      </div>
      <div class="form-region">
        <h4 class="display-1">password</h4>
        <v-text-field type="password" label="Password *" hint="Password must be at least 8 characters long and ONLY contain the letters a to z in either upper or lowercase, and the numbers 0 to 9." v-model="form.password.password" :rules="[rules.passwordValidity]"
          :validate-on-blur=true></v-text-field>
        <v-text-field type="password" label="Confirm password *" hint="Should match your above password, this detects typos." v-model="form.password.confirm"
          :rules=[rules.required]></v-text-field>
      </div>
      <v-layout justify-end>
        <v-btn v-if="!sending" type="submit" color="primary">Submit</v-btn>
        <v-btn v-if="!sending" v-on:click="$refs.form.reset()">Clear</v-btn>
        <ball-scale-loader v-if="sending" color="#1976d2"/>
      </v-layout>
    </v-form>
    <div id="registration-success" v-if="success">
      <SVGTick class="svg-tick"/>
      <p>Your account has been created. You must confirm your email address before you can sign in.</p>
      <p>A confirmation email has been sent to the address provided.</p>
      <p>Return to <router-link to="i/user/signin">sign in</router-link>.</p>
    </div>
  </div>
</template>

<script>
import { BallScaleLoader } from 'vue-loaders';
import SVGTick from 'assets/svg/tick.svg'
import CommonRules from 'src/common-rules.js';
import Authentication from '@/services/AuthenticationApi';
export default {
  name: 'app',
  components: {
    BallScaleLoader,
    SVGTick,
  },
  created: () => {
    document.title = 'ThinkSpatial | Register';
  },
  data() {
    return {
      recaptcha: null,
      success: false,
      error: null,
      sending: false,
      rules: CommonRules,
      form: {
        user: {
          first: null,
          last: null,
          email: null,
        },
        password: {
          password: null,
          confirm: null
        }
      }
    }
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault();
      alert(JSON.stringify(this.form));
    },

    async submitClicked() {
      if (!this.$refs.form.validate()) {
        console.log('not valid');
        return;
      }

      if (this.form.password.password !== this.form.password.confirm) {
        this.$swal({
          title: 'Oops!',
          text: 'Your password confirmation did not match your password.',
          type: 'error'
        });
        return;
      }

      try {
        console.log(this.form.user.first, this.form.user.last, this.form.user.email, this.form.password.password)     
        const response = await Authentication.register({
          first_name: this.form.user.first,
          last_name: this.form.user.last,
          email: this.form.user.email,
          password: this.form.password.password
        })

        this.$store.dispatch('setToken', response.data.token)
        this.$store.dispatch('setUser', response.data.user)
        this.$router.push({
          name: 'default'
        })
      } catch (err) {
        console.log(err)
        this.$swal({
          title: 'Ouch!',
          text: 'An unknown error has occurred. Please try again.',
          type: 'error'
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import 'assets/landing.scss';  

  .float-right {
    vertical-align: middle;
    float: right;
  }

  #registration-success {
    text-align: center;
    padding: 60px 0;
  }

  @media (min-width: 600px) {
    #registration-success {
      margin-left: 60px;
    }
  }
  
</style>